import React from "react"

const BlockNotFound = ({ type }) => (
  <div className="px-4 py-2 m-2 font-bold text-white bg-red-500 rounded">
    Block "{type}" is not defined. Add it to _Blocks.js
  </div>
)

export default BlockNotFound
